<section class="select-alert" role="dialog" aria-modal="true" aria-labelledby="modal-title">
  <header class="select-alert-header">
    <h2 id="modal-title" class="select-alert-title">{{ modalTitle }}</h2>
    @if (allowMultipleSelection() && allowSelectAllSelection()) {
      <button type="button" class="select-alert-action" (click)="onToggleAll()">
        {{ allSelectableSelected() ? 'Clear' : 'Select all' }}
      </button>
    }
  </header>

  @if (showSearchBar) {
    <div class="select-alert-search">
      <input
        type="search"
        placeholder="Search stores"
        [value]="searchQuery()"
        (input)="onSearch($event)" />
    </div>
  }

  <div
    class="select-alert-body"
    [attr.role]="allowMultipleSelection() ? 'group' : 'radiogroup'"
    [attr.aria-labelledby]="'modal-title'">
    @for (key of visibleOptionKeys(); track key) {
      <button
        type="button"
        class="select-alert-option"
        [attr.role]="allowMultipleSelection() ? 'checkbox' : 'radio'"
        [attr.aria-checked]="selectOptions()[key].selected"
        [attr.title]="selectOptions()[key].tooltip"
        [disabled]="selectOptions()[key].disabled"
        (click)="onSelectOption(key)">
        @if (allowMultipleSelection()) {
          <span class="select-alert-checkbox" [class.checked]="selectOptions()[key].selected" aria-hidden="true">
            @if (selectOptions()[key].selected) {
              <app-display-icon
                [border]="false"
                [colour]="iconColourEnum.white"
                [icon]="icons.checkBold">
              </app-display-icon>
            }
          </span>
        } @else {
          <app-display-icon
            [border]="false"
            [colour]="selectOptions()[key].selected ? iconColourEnum.primary : iconColourEnum.secondary"
            [icon]="selectOptions()[key].selected ? icons.radioBoxMarked : icons.radioBoxBlank">
          </app-display-icon>
        }
        <span class="select-alert-option-label">{{ selectOptions()[key].name }}</span>
      </button>
    }
  </div>

  <footer class="select-alert-footer">
    <button type="button" class="select-alert-action" (click)="onCancel()">
      {{ buttonCloseText }}
    </button>
    <button type="button" class="select-alert-action" [disabled]="!hasSelection()" (click)="onConfirm()">
      {{ buttonAcceptText }}
    </button>
  </footer>
</section>
